__webpack_require__.p = "https://go.tau.ac.il/sites/default/files/react_bundle/";